import { PATH } from '@/constants/path';
import Dashboard from '@/pages/Dashboard';
import DeliverySettingsPage from '@/pages/DeliverySetting';
import EmailCustomerNotification from '@/pages/EmailCustomerNotification';
import GeneralSetting from '@/pages/GeneralSetting';
import LocationPage from '@/pages/Location';
import EditLocation from '@/pages/Location/component/Form';
import Onboarding from '@/pages/Onboarding';
import OrderReport from '@/pages/OrderReport';
import PickupSettingsPage from '@/pages/PickupSetting';
import Pricing from '@/pages/Pricing';
import ShippingSetting from '@/pages/ShippingSetting';
import Translation from '@/pages/Translation';
import TranslationDetail from '@/pages/Translation/component/TranslationDetail';
import WidgetAppearancePage from '@/pages/WidgetAppearance';
import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, Route, Routes } from 'react-router-dom';

interface IRouter {
  path: string;
  element: React.ReactNode;
}

interface IEmbedRouter extends Pick<IRouter, 'path'> {
  label: string;
}

const ErrorFallback = () => (
  <div style={{ padding: '20px', textAlign: 'center' }}>
    <h2>Something went wrong!</h2>
    <p>Failed to load this page. Please refresh and try again.</p>
  </div>
);

export const router: Array<IRouter> = [
  {
    path: PATH.ONBOARDING.pathname,
    element: <Onboarding />,
  },
  {
    path: PATH.DEFAULT.pathname,
    element: <Dashboard />,
  },
  {
    path: PATH.SETTINGS__CHECKOUT.pathname,
    element: <GeneralSetting />,
  },
  {
    path: PATH.SETTINGS__EMAIL.pathname,
    element: <GeneralSetting />,
  },
  {
    path: PATH.SETTINGS__DELIVERY_VALIDATION.pathname,
    element: <GeneralSetting />,
  },
  {
    path: PATH.SETTINGS__ORDER_MANAGEMENT.pathname,
    element: <GeneralSetting />,
  },
  {
    path: PATH.SETTINGS__ADVANCED_SETTING.pathname,
    element: <GeneralSetting />,
  },
  {
    path: PATH.SHIPPING.pathname,
    element: <ShippingSetting />,
  },
  {
    path: PATH.LOCATIONS.pathname,
    element: <LocationPage />,
  },
  {
    path: `${PATH.LOCATIONS.pathname}/new`,
    element: <EditLocation />,
  },
  {
    path: `${PATH.LOCATIONS.pathname}/:id`,
    element: <EditLocation />,
  },
  {
    path: `${PATH.PICKUP.pathname}/:id`,
    element: <PickupSettingsPage />,
  },
  {
    path: `${PATH.DELIVERY.pathname}/:id`,
    element: <DeliverySettingsPage />,
  },
  {
    path: `${PATH.DELIVERY.pathname}/new/:zoneId`,
    element: <DeliverySettingsPage />,
  },
  {
    path: PATH.WIDGET.pathname,
    element: <WidgetAppearancePage />,
  },
  {
    path: PATH.REPORT.pathname,
    element: <OrderReport />,
  },
  {
    path: PATH.PRICING.pathname,
    element: <Pricing />,
  },
  {
    path: PATH.CUSTOM_NOTI_PICKUP_EMAIL.pathname,
    element: <EmailCustomerNotification />,
  },
  {
    path: PATH.CUSTOM_NOTI_DELIVERY_SHIPPING_EMAIL.pathname,
    element: <EmailCustomerNotification />,
  },
  {
    path: PATH.TRANSLATION.pathname,
    element: <Translation />,
  },
  {
    path: `${PATH.TRANSLATION.pathname}/:id`,
    element: <TranslationDetail />,
  },
];

export const embeddedRouter: Array<IEmbedRouter> = [
  {
    label: 'Locations',
    path: PATH.LOCATIONS.pathname,
  },
  {
    label: 'Shipping',
    path: PATH.SHIPPING.pathname,
  },
  {
    label: 'Widget Appearance',
    path: PATH.WIDGET.pathname,
  },
  {
    label: 'Translation',
    path: PATH.TRANSLATION.pathname,
  },
  {
    label: 'General Settings',
    path: PATH.SETTINGS__CHECKOUT.pathname,
  },
  {
    label: 'Order report',
    path: PATH.REPORT.pathname,
  },
  {
    label: 'Pricing',
    path: PATH.PRICING.pathname,
  },
];

function RenderRouter() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Suspense
        fallback={
          <div
            style={{
              opacity: 0,
              minHeight: 'calc(100vh - 5rem)',
              width: '100%',
            }}
          >
            Loading...
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Navigate to={PATH.DEFAULT} replace />} />
          {router.map((item: IRouter) => (
            <Route key={item.path} path={item.path} element={item.element} />
          ))}
          <Route path="*" element={<Navigate to={PATH.DEFAULT} replace />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}
export default RenderRouter;
